exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._37NsGGN-FfbF-1gFNb0dJD ._2Zt1mr6X7utc4krjKGqoYz ._3Tl2Jh8t2_p5-1awLjnuZi{position:absolute;left:0;width:100%;height:100%}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_37NsGGN-FfbF-1gFNb0dJD",
	"margin-view-overlays": "_2Zt1mr6X7utc4krjKGqoYz",
	"cmdr": "_3Tl2Jh8t2_p5-1awLjnuZi"
};